import { useQuery } from "@tanstack/react-query";
import permissionRepository from "@/repository/permissionRepository";


const getData = async (agentId: number) => {
    const res = await permissionRepository.find(agentId);
    return res.data?.data || [];
};

export const usePermissions = (agentId: number) => {
    return useQuery<string[]>({
        queryKey: ["permission", "agent", agentId],
        queryFn: async () => getData(agentId),
        retry: false
    });
};
